import {
  Component,
  ContentChild,
  Directive,
  HostListener,
  ElementRef,
  Output,
  EventEmitter,
  Renderer2, Input,
} from '@angular/core';

@Directive({
  selector: '[dropdownContent]'
})
export class DropdownContentDirective {
  constructor(public elementRef: ElementRef) {
  }
}

@Directive({
  selector: '[dropdownToggle]'
})
export class DropdownToggleDirective {
  constructor(private dropdown: DropdownComponent, public elementRef: ElementRef) {
  }

  @HostListener('click', ['$event'])
  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.dropdown.toggle();
  }
}

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss'
})
export class DropdownComponent {
  static openDropdown: DropdownComponent | null = null;

  @ContentChild(DropdownContentDirective, {static: false}) dropdownContent?: DropdownContentDirective;
  @ContentChild(DropdownToggleDirective, {static: false}) dropdownToggle?: DropdownToggleDirective;

  @Input() disabled = false;
  @Input() removeArrow: boolean = false;
  @Input() openDropdownUpwards: boolean = false;
  @Input() leftAlign: boolean = false;
  isOpen = false;
  @Output() openChange = new EventEmitter<boolean>();
  @Output() dropdownClosed = new EventEmitter<boolean>();
  @Input() isDropdownListFullWidth: boolean = false;
  @Input() isDarkDropdown: boolean = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
  }


  ngAfterViewInit() {
    if (!this.removeArrow && this.dropdownToggle && this.dropdownToggle.elementRef && this.dropdownToggle.elementRef.nativeElement) {
      const icon = this.renderer.createElement('i');
      this.renderer.addClass(icon, 'fas');
      this.renderer.addClass(icon, 'fa-chevron-down');
      this.renderer.addClass(icon, 'scale-80');
      this.renderer.setAttribute(icon, 'id', 'icon');
      this.renderer.appendChild(this.dropdownToggle.elementRef.nativeElement, icon);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (this.dropdownContent && !this.dropdownContent.elementRef.nativeElement.contains(event.target) &&
      this.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.close();
    }
  }

  toggle(): void {
    if (!this.disabled) {
      if (DropdownComponent.openDropdown && DropdownComponent.openDropdown !== this) {
        DropdownComponent.openDropdown.close();
      }

      this.isOpen = !this.isOpen;
      DropdownComponent.openDropdown = this.isOpen ? this : null;

      this.updateIcon();
      this.openChange.emit(this.isOpen);
    }
  }

  close(): void {
    if (!this.disabled) {
      this.isOpen = false;
      if (DropdownComponent.openDropdown === this) {
        DropdownComponent.openDropdown = null;
      }
      this.updateIcon();
      this.dropdownClosed.emit(true);
    }
  }

  updateIcon() {
    if (!this.removeArrow && this.dropdownToggle && this.dropdownToggle.elementRef && this.dropdownToggle.elementRef.nativeElement) {
      const icon = this.dropdownToggle.elementRef.nativeElement.querySelector('#icon');
      if (icon) {
        this.renderer.removeClass(icon, 'fa-chevron-down');
        this.renderer.removeClass(icon, 'fa-chevron-up');
        this.renderer.addClass(icon, this.isOpen ? 'fa-chevron-up' : 'fa-chevron-down');
      }
    }
  }
}


@Directive({
  selector: '[dropdownItem]'
})
export class DropdownItemDirective {
  constructor(private dropdown: DropdownComponent) {
  }

  @HostListener('click', ['$event'])
  toggleDropdown(event: Event) {
    this.dropdown.close();
    event.stopPropagation();
  }
}


